import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AssignTask } from '../classes/assign-task';
import { CreateAddOnPayload } from '../classes/create-addon-payload';
import { RemoveAddOnPayload } from '../classes/remove-addon-payload';
import { ConfigurationService } from './configuration.service';
import { LoggerService } from './logger.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class UnassignedTasksService {

  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    private toastService: ToastService,
    private logger: LoggerService) { }

  private getTaskUrl(taskId: string): string {
    const config = this.configurationService.configuration$.getValue();
    if (!config) {
      throw new Error('Configuration not loaded');
    }
    return config.HostApi.concat('/task/').concat(taskId);
  }

  assignTask(payload: AssignTask): Observable<HttpResponse<any>>{
    const url = this.getTaskUrl(payload.taskIds[0]);
    return this.http
      .put<any>(url, payload, {
        headers: new HttpHeaders({"Content-Type": "application/json"}),
        observe: "response"
      })
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError(error, 'Failed to assign task'))
      );
  }

  createAddOn(payload: CreateAddOnPayload, taskName: string): Observable<HttpResponse<any>>{
    const url = this.getTaskUrl(taskName);
    const headers = new HttpHeaders().set("Content-type", "application/json; charset=utf-8");
    return this.http.put<HttpResponse<any>>(url, JSON.stringify(payload), { "headers":headers, observe: 'response' }).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error, 'Failed to create add-on'))
    );
  }

  removeAddOn(payload: RemoveAddOnPayload, taskName: string): Observable<HttpResponse<any>>{
    const url = this.getTaskUrl(taskName);
    const headers = new HttpHeaders().set("Content-type", "application/json; charset=utf-8");
    return this.http.put<HttpResponse<any>>(url, JSON.stringify(payload), { "headers":headers, observe: 'response' }).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error, 'Failed to remove add-on'))
    );
  }

  private handleError(error: HttpErrorResponse, message: string) {
    if (error.status === 409 && error.error?.reason === 'DRIVER_HAS_NO_VAN') {
      this.toastService.show('Selected driver does not have a van assigned.', { classname: 'bg-danger text-light', delay: 8000 });
    } else {
      this.toastService.show('HTTP Error Occurred!', { classname: 'bg-danger text-light', delay: 8000 });
    }
    if (error.status === 0) {
      this.logger.error(`${message}:`, error.error);
    } else {
      this.logger.error(`${message}: ${error.status}, body was: ${error.error}`);
    }
    return throwError(error);
  }
}
